<template>
    <mdb-container fluid>
        <div v-if="loading" class="justify-content-md-center" style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: rgba(0,0,0,0.5);
            z-index: 100;">
            <div style="width: 100px;height: 100px;border-color: black;" class="spinner-border"></div>
            <div style="margin-top: 10px;">Loading....</div>
        </div>
        <mdb-row class="justify-content-md-center">
           <mdb-col lg="10" text-center>
            <mdb-col md="4" > 
                <mdb-card v-if="iswithToken==false" class="login-box" role="main">
                <mdb-card-body>
                   <!-- Material form login 
                <form>-->
                <!--<p class="h4 text-center mb-4">Sign in</p>-->
                
                <h1 class="text-center mb-4" style="font-size: 30px;">Sign in</h1>
                    <div class="grey-text">
                        <mdb-input label="Company Code" icon="envelope" ref="ccode" type="text" v-model="user" @keyup.enter.native="validateLogin(false)" autocomplete="username"/>
                        <mdb-input label="Your password" icon="lock" type="password" ref="psw" v-model="pass" @keyup.enter.native="validateLogin(false)" autocomplete="current-password"/>
                
                    </div>
                <div class="text-center">
                    <mdb-btn v-on:click="validateLogin(false)" class="btn-login">Login</mdb-btn>
                </div>
                <!-- <div>
                    <div class=" orsection"><span class="orspan">OR</span></div>
                    <div class="text-center">
                        <mdb-btn v-on:click="sso_url" class="btn btn-login btn-sso">Login with Company Account</mdb-btn>
                    </div>
                </div> -->
                <div class="text-center" role="alert" >
                    <mdb-badge pill color="white" :v-if="err" aria-atomic="true">{{err}}</mdb-badge>
                </div>
               <!-- </form>
             Material form login -->
                </mdb-card-body>
                </mdb-card>
                <img v-else :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
            </mdb-col>
           </mdb-col>      
        </mdb-row>        
  </mdb-container>
</template>
<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn,mdbCard, mdbCardBody,mdbBadge,mdbSpinner } from 'mdbvue';
export default {
    name: 'Body',
    data(){
        return{user:'', loading:false,
        pass:'',message:'',err:'',
        LOCAL_HOST:this.$store.state.LOCAL_HOST,
        iswithToken:false
        }
    },
    components:{
        mdbContainer,
        mdbRow,
        mdbCol,mdbInput, mdbBtn,mdbCard, mdbCardBody, mdbBadge, mdbSpinner
    },
    mounted(){
        if(typeof(this.$route.params.token)!=='undefined'){
            this.iswithToken=true;
        }
        else{
            this.iswithToken=false;
        }

        if(this.$route.query.code)
        {
            this.loading=true;
            //console.log('code param is available',this.$route.query.code);
            const config = {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('code', this.$route.query.code)

            axios.post(this.$store.state.apiUrl+'/sso_user_by_code',formData,config)
            .then(response => {
                //console.log(response.data);
                this.validateLogin(response.data);
                this.loading =  false;
            })
            .catch(() => {
                this.err='Unable to get SSO Login URL';
                this.loading =  false;
            });
        }
    },
    created(){       
        let encrypt_flag = localStorage.encrypt_flag;
        let id_eap = localStorage.id_eap;
        let filename = localStorage.filename;
        localStorage.clear();   
        localStorage.encrypt_flag = encrypt_flag;
        localStorage.id_eap = id_eap;
        localStorage.filename = filename; 
        document.documentElement.setAttribute("lang", "en"); 
        Weglot.switchTo('en');     
        document.title="Login";
    },
    methods:{
        sso_url:function(){
            axios.post(this.$store.state.apiUrl+'/sso_url')
                .then(response => {
                    //console.log(response.data);
                   window.location.href = response.data.authUrl;
                })
                .catch(() => {
                    this.err='Unable to get SSO Login URL'
                });
        },
        validateLogin:function(sso_user){
           //alert('in mdb login');
            this.err="";
            if(this.user=='' && !sso_user){
                this.err='Enter the Company code'
                this.$refs.ccode.focus();
                return false;
            }
            if(this.pass=='' && !sso_user){
                this.err='Enter the Password'
                this.$refs.psw.focus();
                return false;
            }
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('username', sso_user ? sso_user.mail : this.user)
            formData.append('password', this.pass)
            formData.append('origref', document.referrer)
            
            if(localStorage.encrypt_flag!='undefined'){
                formData.append('encrypt_flag', localStorage.encrypt_flag)
            }else{ localStorage.encrypt_flag = 0;}

            if(localStorage.filename!='undefined'){
                formData.append('filename', localStorage.filename)
            }
            if(localStorage.id_eap !='undefined'){
                formData.append('id_eap', localStorage.id_eap)
            } 

            let action = '/login';
            if ( sso_user ) action = '/loginsso';
            axios.post(this.$store.state.apiUrl+ action,formData,config)
            .then(response => {
                var messageer= response.data;
                response = response.data[0]

                if(response === undefined || response.length == 0 ){   
                    if(messageer.message){
                        this.err=messageer.message;
                    }
                    else{
                        this.err='! Invalid Credential or No Access'
                    }
                    this.user = '';
                    this.pass= '';
                    this.$refs.ccode.focus();
                }
                else{
                    this.$store.state.companyData=response
                    this.$store.state.companyData['custom_text_1'] = response.custom_text_1
                    this.$store.state.companyData['custom_text_2'] = response.custom_text_2
                    this.$store.state.companyData['custom_text_3'] = response.custom_text_3
                    this.$store.state.companyData['custom_text_4'] = response.custom_text_4
                    this.$store.state.companyData['custom_text_5'] = response.custom_text_5
                    this.$store.state.companyData['id_company'] = response.id_company
                    this.$store.state.companyData['encrypt_key'] = response.encrypt_key
                    this.$store.state.companyData['filename'] = response.filename
                    this.$store.state.companyData['id_design'] = response.id_design
                    this.$store.state.companyData['id_eap'] = response.id_eap
                    this.$store.state.companyData['id_service'] = response.id_service
                    this.$store.state.companyData['name_company'] = response.name_company
                    this.$store.state.companyData['name_css'] = response.name_css
                    this.$store.state.companyData['id_language'] = response.language_id_default.substr(3,3)
                    this.$store.state.companyData['id_country'] = response.language_id_default.substr(0,3)
                    this.$store.state.companyData['id_session'] = response.id_session
                    this.$store.state.companyData['login_user'] = response.logname
                    this.$store.state.companyDataInfo.company_logo=response.company_logo
                    localStorage.company_logo=response.company_logo
                    localStorage.id_company = response.id_company;
                    localStorage.id_design = response.id_design;
                    localStorage.id_eap = response.id_eap;
                    localStorage.id_service = response.id_service;
                    localStorage.id_service_link = response.id_service_link;
                    localStorage.id_language = response.language_id_default.substr(3,3);
                    localStorage.id_country = response.language_id_default.substr(0,3);
                    localStorage.custom_text_1 = response.custom_text_1;
                    localStorage.encrypt_key = response.encrypt_key;
                    localStorage.name_company = response.name_company;
                    localStorage.custom_text_2 = response.custom_text_2;
                    localStorage.custom_text_3 = response.custom_text_3;
                    localStorage.custom_text_4 = response.custom_text_4;
                    localStorage.custom_text_5 = response.custom_text_5;
                    localStorage.id_session = response.id_session;
                    localStorage.login_user = response.logname;
                    localStorage.filename = response.filename;
                   
                   // console.log('qqqqqwewewe-',this.$store.state.companyData )
                    //console.log('w-',this.$store.state.companyData )
                    if(response.language_id_default==""){
                      //console.log('lang blank in mdb common login')                       
                      this.$router.push({path:'/languageChooser'})     
                      return false                 
                    }
                    //console.log('sid');
                    //api_private_key=this.$store.state.generate_privatekey('geme')
                    this.$store.dispatch('getTheme');
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$store.dispatch('getCompanyDataInfo');

                    if( sessionStorage.getItem('intended_url') != '' && sessionStorage.getItem('intended_url') != null)
                    {
                        let intended_url = sessionStorage.getItem('intended_url');
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:intended_url});
                    }
                    else
                    {
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:'/'})
                    }
                }
                
            })
            .catch(() => {
                this.company_data = [];
                this.err='Try after sometime'
            });
            event.preventDefault();
        }
    }
 
};
</script>
<style scoped>
.login-box{
    margin-top: 55px;    
    padding: 10px;
}
.btn-login{
    background-color: #245d89 !important;    
    color: #fff !important;
}
.btn-login:focus {
    background-color: #186860 !important;
    outline: 2px dotted #e9f8ff !important;
    border: 2px dotted #1d1d1d !important;
    outline-offset: -1px !important;
}
.badge{
    font-size: 85%;    
    white-space: inherit;
    padding: 7px;
}
.text-center span{
    color: #D3350D !important;
}
::v-deep .md-form label {
    color:#595959 !important;
}
.btn-sso{
    background-color: #ffffff !important;
    color: #2d2b2b !important;
    -webkit-box-shadow: 0 2px 5px 0 rgb(0 0 0 / 1%), 0 2px 10px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 1%), 0 2px 10px 0 rgb(0 0 0 / 12%);
    padding: 9px 10px;
    text-transform: none;
}
.btn-sso:hover{
    box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);
    
}
.btn-sso:focus{
    color:#FFF !important;
}
.orsection{
     border-top: 1px solid #cfceceab; text-align: center; position: relative;
     margin-top: 22px;
}
.orspan{
    position: relative; top: -.8em; background: white; display: inline-block;
    color: #9f9f9fd1 !important;
}
</style>
